import { v4 as uuidv4 } from "uuid";
import { observer } from "mobx-react-lite";

import { ReportCard } from "components";
import { REPORT_TYPE_ENUM } from "interfaces";
import { ENDPOINTS } from "services";
import { useStores } from "stores";

export const RequestReportModal = observer(() => {
  const { companyCard } = useStores();
  return (
    <ReportCard
      title="Отчет о заявках"
      datePickerType="range"
      reportType={REPORT_TYPE_ENUM.REQUESTS}
      key={uuidv4()}
      customEndpoint={ENDPOINTS.requestReport(companyCard.card.id)}
      vertical
      showTitle={false}
    />
  );
});
